export const MediaLibFoldersSkeleton = () => {
  return (
    <div className="tw-flex tw-animate-skeleton-loading tw-items-center tw-space-x-3 tw-rounded-lg tw-bg-blue-50 tw-p-4">
      <div className="tw-size-4 tw-rounded tw-bg-blue-200/50" />
      <div className="tw-h-2 tw-w-3/5 tw-rounded tw-bg-blue-200/50" />
    </div>
  );
};
